<template>
  <div class="container">
    <vue-final-modal v-model="show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left text-center">
          <span class="modal__title">STOCK CARD</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <div class="row">
          <div class="col-6">
            <p style="margin-top: 0px;">
              ITEM CODE &ensp;: <input class="form-control d-inline-block" style="width: auto;" :value="materialCode" disabled><br>
              ITEM NAME &ensp;: <strong>{{ itemName }}</strong>
            </p>
            <button type="button" class="btn btn-sm bg-gradient-primary mb-0" @click="openDetail()">
              <i class="fa fa-eye fa-sm" aria-hidden="true"></i> Detail Barang
            </button>
          </div>
          <div class="col-6">
            <p class="mb-1">PERIODE :</p>
            <flat-pickr :config="{ mode: 'range' }" class="form-control" placeholder="Semua Periode" v-model="periode" @on-close="get()" />
          </div>
        </div><hr>
        <div class="table-responsive p-0 scroll">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder bg-primary">No</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder bg-primary">Description</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder bg-primary">Date</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder bg-primary">Stock In</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder bg-primary">Issued</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder bg-primary">WO No.</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder bg-primary">Ending Stock</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in table.data" :key="i">
                <td class="align-middle text-center text-sm">{{ row.no }}</td>
                <td class="align-middle text-sm">{{ row.description }}</td>
                <td class="align-middle text-center text-sm">{{ (row.date && row.date != '0000-00-00') ? moment(row.date).locale('id').format('LL') : '-' }}</td>
                <td class="align-middle text-center text-sm">{{ row.stock_in ? row.stock_in : '' }}</td>
                <td class="align-middle text-center text-sm">{{ row.issued ? row.issued : '' }}</td>
                <td class="align-middle text-center text-sm">{{ row.wo_no }}</td>
                <td class="align-middle text-center text-sm">{{ row.ending_stock }}</td>
              </tr>
              <tr v-if="table.data.length === 0">
                <td colspan="7" class="text-center text-sm py-3">Belum ada history</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vue-final-modal>
  </div>
</template>

<script>
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import stockBarang from '@/services/stockBarang.service';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
var moment = require('moment');

export default {
  name: "stock-card-modal",
  components: {
    VueFinalModal,
    flatPickr,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    materialCode: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      moment: moment,
      itemName: '',
      periode: '',
      table: {
        data: []
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
  watch: {
    materialCode(val) {
      if (val) {
        this.periode  = '';
        this.itemName = '';
        this.get();
      }
    },
  },
  methods: {
    openDetail() {
      let route = this.$router.resolve({ name: 'DetailBarang', params: { material_code: this.materialCode } });
      window.open(route.href, '_blank');
    },
    get() {
      let context   = this;
      let dateStart = '';
      let dateEnd   = '';

      if (context.periode) {
        dateStart = context.periode.substring(0, 10);
        dateEnd   = context.periode.substring(context.periode.length - 10);
      }

      Api(context, stockBarang.stockCard(context.materialCode, {date_start: dateStart, date_end: dateEnd})).onSuccess(function(response) {
          context.itemName   = response.data.data.material_name;
          context.table.data = response.data.data.data;
      }).onError(function(error) {
          context.table.data = [];
      })
      .call()
    },
  },
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content-width {
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 900px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1.1rem;
  font-weight: 700;
}
.scroll {
  overflow: auto;
  max-height: 400px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
}
</style>
